import { datetimeFormatter } from 'transfix-ui'

export const formatTimeForBidderConfig = (time?: string | null) => {
  const result = time
    ? datetimeFormatter({
        datetime: time,
        displayTimezone: 'America/New_York',
        format: 'timeDateAndYear',
      })
    : 'N/A'
  return result
}
